import React, { useCallback, useContext, useState } from 'react';
import FullPageTransition from 'app/home/general-components/FullPageTransition';
import { RoomSelectDevice, RoomSelectNameAndIcon } from '../Detail';
import { CurrentPageContext } from 'app/home/general-components/HistoryStackContext';


import './AddRoom.scss'

export default function AddRoom({ roomsController, devices }) {
    const p = useContext(CurrentPageContext);

    const dismissHandler = p.dismiss;

    const [inverse, setIsBackInProgress] = useState(false);
    const [page, setPage] = useState("select-device");
    const [selectedMacs, setSelectedMacs] = useState([]);

    const setSelectedMacsCallback = useCallback((macs) => {
        setSelectedMacs(macs);
        setPage("select-info");
    }, []);

    const setInfoCallback = useCallback((name, avatar, color) => {
        roomsController.newRoom({
            "device_macs": selectedMacs,
            "name": name,
            "avatar": avatar,
            "color": color,
        });
        dismissHandler();
    }, [roomsController, selectedMacs, dismissHandler]);

    const onInfoPageBackClick = useCallback(() => {
        setIsBackInProgress(true);
        setTimeout(() => {
            setPage("select-device");
            setTimeout(() => {
                setIsBackInProgress(false);
            }, 500);
        });
    }, []);

    return (
        <div className="add-room-page">
            <div className="bg-blank" />
            <div className="bg-secondary-color" />
            <FullPageTransition disableOnFirstTime inverse={inverse}>
                <RoomSelectDevice
                    createRoomMode={true} createRoomModeBackHandler={dismissHandler}
                    defaultSelectedMacs={selectedMacs}
                    setSelectedMacsCallback={setSelectedMacsCallback}
                    devices={devices}

                    isVisible={page === "select-device"}
                    key="add-room-full-page-select-device" />

                <RoomSelectNameAndIcon
                    createRoomMode={true} createRoomModeBackHandler={onInfoPageBackClick}
                    setInfoCallback={setInfoCallback}

                    isVisible={page === "select-info"}
                    key="add-room-full-page-select-info" />
            </FullPageTransition>
        </div>
    )
}